import { z } from "zod";

export const schema = z.object({
    company: z.string().min(1, "forms.general-validation.company_name_required").max(100, "forms.general-validation.company_name_max_100"),
    logo: z.string().nullable(),
    fee: z.string(),
    status: z.string(),
    statusType: z.enum(["active", "inactive"], {
        required_error: "forms.general-validation.status_required",
    }),
    approvalProbability: z.string(),
    link: z.string().url("forms.general-validation.link_valid_url"),
    approvalChance: z.string(),
});

export type FormDesignPreviewEditFormData = z.infer<typeof schema>;
